<!--
 * @Author: gang.liu
 * @Date: 2021-06-28 09:21:03
 * @LastEditTime: 2021-06-29 17:24:22
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
-->
<template>
  <div
    class="gy-body"
    :style="{ backgroundImage: 'url(' + require('@/assets/bg.jpg') + ')' }"
  ></div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="less">
.gy-body {
  height: calc(100vh - 160px);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
</style>
